































































































import { Component, Vue } from 'vue-property-decorator'
import Pagination from '@/components/Pagination/index.vue'
import { SorewardsProgram } from '@/models/index'
import { clipboardSuccess } from '@/utils/clipboard'
import SorewardsProgramTypeDisplay from '@/views/sorewards/programs/program-type-display.vue'

@Component({
  name: 'SorewardsProgramsTable',
  components: {
    Pagination,
    SorewardsProgramTypeDisplay
  }
})
export default class extends Vue {
  private list: SorewardsProgram[] = []
  private total = 0
  private listLoading = true
  private listQuery: {
    page: number
    limit: number
    name: string | undefined
  } = {
    page: 1,
    limit: 20,
    name: undefined
  }

  private clipboardSuccess = clipboardSuccess

  private async getList() {
    this.listLoading = true

    try {
      let scope = SorewardsProgram
        .page(this.listQuery.page)
        .per(this.listQuery.limit)
        .order({ createdAt: 'desc' })
        .stats({ total: 'count' })

      if (this.listQuery.name) {
        scope = scope.where({ name: { prefix: this.listQuery.name } })
      }

      const { data, meta } = await scope.all()

      this.list = data
      this.total = meta.stats.total.count
    } finally {
      this.listLoading = false
    }
  }

  private handleFilter() {
    this.listQuery.page = 1
    this.getList()
  }

  private onRowClick(row: SorewardsProgram) {
    this.$router.push({ name: 'SorewardsProgramShow', params: { id: row.id } })
  }

  created() {
    this.getList()
  }
}
